// extracted by mini-css-extract-plugin
export default {"datenschutzContainer":"Datenschutz_datenschutzContainer__Vh5CU"};